// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo {\n  width: 134px;\n  height: 48.6px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.logo:hover {\n  -webkit-filter: opacity(75%);\n          filter: opacity(75%);\n}\n.logoSwitchVenue {\n  width: 72px;\n  height: 26px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.logoSwitchVenue:hover {\n  -webkit-filter: opacity(75%);\n          filter: opacity(75%);\n}", ""]);
// Exports
module.exports = exports;
